import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/constants";

const COLS = [
  {
    title: "Intelligence",
    links: [["News", "/news"], ["Research", "/research"], ["Conviction", "/conviction"], ["Analysts", "/analysts"]],
  },
  {
    title: "Explore",
    links: [["Calendar", "/calendar"], ["Membership", "/pricing"]],
  },
  {
    title: "Membership",
    links: [["Whitelist", "/pricing"], ["Join Alpha", "/pricing"], ["Log in", "/login"]],
  },
];

export function Footer() {
  return (
    <footer className="border-t border-white/10 mt-24 bg-[#070707]">
      <div className="max-w-[1400px] mx-auto px-6 py-14">
        <div className="grid md:grid-cols-[1.6fr_1fr_1fr_1fr] gap-10">
          <div>
            <img src={LOGO_URL} alt="OnchainLyfe" className="h-8 w-auto mb-4" />
            <p className="text-zinc-400 text-sm max-w-xs leading-relaxed">
              Independent onchain media, research, and intelligence. Connecting market narratives, curated analysts, and the next generation of digital asset participants.
            </p>
            <p className="mt-4 font-mono-cl text-[11px] tracking-[0.2em] text-[#ccff00] uppercase">
              Where Narratives Become Conviction
            </p>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <p className="font-mono-cl text-[11px] tracking-[0.2em] text-zinc-500 uppercase mb-4">{c.title}</p>
              <ul className="space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="text-sm text-zinc-300 hover:text-[#ccff00] transition-colors">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-zinc-600">© {new Date().getFullYear()} OnchainLyfe. Markets intelligence, not financial advice.</p>
          <p className="text-xs text-zinc-600">The ultimate product is information advantage.</p>
        </div>
      </div>
    </footer>
  );
}
